module.exports = __webpack_public_path__ + "static/media/logo.e83c103e.png";